module.exports = __webpack_public_path__ + "HP_Latex_application_enviro-car_wrapping.jpg?38acc33526c43eca3bf3b948ec4ffea3";